export default __webpack_public_path__ + "static/media/prototypeBanner.41167586.webp";